import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getLocationTypeLaborHr(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.GET_LOCATION_TYPE_LOADER });
    const response = yield call(laborHoursService.getLocationType);
    if (response?.status === 200) {
      yield put({ type: laborHoursConstant.GET_LOCATION_TYPE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.GET_LOCATION_TYPE_FAILURE, payload: error });
  }
}

function* getLocationTypeLaborHrSaga() {
  yield takeEvery(laborHoursConstant.GET_LOCATION_TYPE_REQUEST, getLocationTypeLaborHr);
}

export default getLocationTypeLaborHrSaga;
